import Hidden from '@material-ui/core/Hidden';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import deepmerge from 'deepmerge';
import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import { SegmentResponse } from '../../models/itinerary';
import { breakpointMobile } from '../lab/breakpoints';
import { spacings } from '../lab/spacings';
import { SegmentDesktop } from './SegmentDesktop';
import { SegmentMobile } from './SegmentMobile';
import { isSaviSelectIntl } from '../../store/reducers/itinerary/selectors';
import { connect } from 'react-redux';
import { AppState } from '../../store/model';

interface OwnProps {
  segmentId: SegmentResponse['orderId'];
}

interface StateProps {
  saviIntl: boolean;
}

interface SegmentProps extends OwnProps,StateProps, WithStyles<typeof styles> {}

class SegmentBase extends PureComponent<SegmentProps> {
  public render() {
    const { segmentId, classes, saviIntl } = this.props;

    return (
      <div className={classes.container}>
        {!saviIntl ? (
          <>
            <Hidden mdUp>
              <SegmentMobile segmentId={segmentId} />
            </Hidden>
            <Hidden smDown>
              <SegmentDesktop segmentId={segmentId} />
            </Hidden>
          </>
        ) : (
          <SegmentDesktop segmentId={segmentId} />
        )}
      </div>
    );
  }
}

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { card: cardSpacing },
    },
  } = spacings(theme);

  const mobile = breakpointMobile(theme);

  return createStyles({
    container: deepmerge(cardSpacing, {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      width: 'auto',
      height: 'auto',
      zIndex: 1,
      [mobile]: {
        marginTop: 0, // for mobile we don't want each segment to be spaced (breaking the normal card behaviour)
      },
      '&:first-of-type': {
        marginTop: 0,
      },
    }) as any,
  });
};

const mapStateToProps = (state: AppState): StateProps => ({
  saviIntl: isSaviSelectIntl(state),
});

const enhance = compose<SegmentProps, OwnProps>(connect(mapStateToProps), withStyles(styles));

/**
 * Segment
 *
 * Switches between SegmentDesktop and SegmentMobile components depending on screensize
 *
 * @see SegmentDesktop
 * @see SegmentMobile
 */
export const Segment = enhance(SegmentBase);

Segment.displayName = 'Segment';
